module.exports = __webpack_public_path__ + "img/cpanel.753a1b15.png";